
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.3 0.5H2.7C1.5 0.5 0.5 1.5 0.5 2.7V18.3C0.5 19.5 1.5 20.5 2.7 20.5H18.3C19.5 20.5 20.5 19.5 20.5 18.3V2.7C20.5 1.5 19.5 0.5 18.3 0.5Z","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M7.0999 13.8H4.8999V16H7.0999V13.8Z"}}),_c('path',{attrs:{"d":"M7.0999 9.39999H4.8999V11.6H7.0999V9.39999Z"}}),_c('path',{attrs:{"d":"M7.0999 4.89999H4.8999V7.09999H7.0999V4.89999Z"}}),_c('path',{attrs:{"d":"M16.1 13.8H8.30005V16H16.1V13.8Z"}}),_c('path',{attrs:{"d":"M16.1 9.39999H8.30005V11.6H16.1V9.39999Z"}}),_c('path',{attrs:{"d":"M16.1 4.89999H8.30005V7.09999H16.1V4.89999Z"}})])
          )
        }
      }
    